// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-context{
    border: solid 1px #ccc;
    display: inline-block;
    margin: 5px;
    background: #FFF;
    color: #000;
    font-family: sans-serif;
    cursor: pointer;
    font-size: 12px;
}

.custom-context-item{
    padding: 5px 25px;
    background-color:#696969;
    color:white;
    cursor: pointer;
}

.dotted-bottom-border {
  border-bottom: dotted 1px #ccc;
}

.custom-modal .ant-modal-body {
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
  width: 300px;
}

.custom-modal .ant-modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
  width: 300px;
}

.custom-modal .ant-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0s;
}

.custom-modal .ant-modal.zoom-enter,
.ant-modal.zoom-appear {
  transform: none;
  opacity: 0;
  animation-duration: 0s;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/custom_context.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,WAAW;IACX,eAAe;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,yBAAyB;UACjB,iBAAiB;AAC3B","sourcesContent":[".custom-context{\n    border: solid 1px #ccc;\n    display: inline-block;\n    margin: 5px;\n    background: #FFF;\n    color: #000;\n    font-family: sans-serif;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.custom-context-item{\n    padding: 5px 25px;\n    background-color:#696969;\n    color:white;\n    cursor: pointer;\n}\n\n.dotted-bottom-border {\n  border-bottom: dotted 1px #ccc;\n}\n\n.custom-modal .ant-modal-body {\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  width: 300px;\n}\n\n.custom-modal .ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: auto;\n  width: 300px;\n}\n\n.custom-modal .ant-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  transition: color 0s;\n}\n\n.custom-modal .ant-modal.zoom-enter,\n.ant-modal.zoom-appear {\n  transform: none;\n  opacity: 0;\n  animation-duration: 0s;\n  -webkit-user-select: none;\n          user-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
